import React from 'react';
import styled from 'styled-components';

const TagWrapper = styled.div`
  max-width: 80px;
  border-radius: 2px;
  font-weight: bold;
  font-size: 10px;
  color: ${p => (p.variant === 'filled' ? p.color : '#FFFFFF')};
  border: 1px solid ${p => p.color};
  text-align: center;
  background-color: ${p => (p.variant === 'outlined' ? p.color : '#FFFFFF')};
`;

const TagFilledWrapper = styled.div`
  max-width: 80px;
  border-radius: 2px;
  font-weight: bold;
  font-size: 10px;
  color: ${p => (p.variant === 'filled' ? p.color : '#FFFFFF')};
  text-align: center;
  background-color: ${p => (p.bgVariant ? p.bgColor : '#FFFFFF')};
`;
const Tag = ({ content, variant, color }) => (
  <TagWrapper color={color} variant={variant}>
    {content}
  </TagWrapper>
);

const TagFilled = ({ content, variant, color, bgVariant, bgColor, className }) => (
  <TagFilledWrapper
    color={color}
    variant={variant}
    bgVariant={bgVariant}
    bgColor={bgColor}
    className={className}
  >
    {content}
  </TagFilledWrapper>
);

export { Tag, TagFilled };
